import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface CTASectionProps {
  onBookCall: () => void;
}

const CTASection = ({ onBookCall }: CTASectionProps) => {
  return (
    <section className="py-16 lg:py-24 bg-gradient-to-br from-primary via-primary/95 to-secondary">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full mb-6">
            <Icon name="RocketLaunchIcon" size={20} variant="solid" className="text-accent" />
            <span className="text-sm font-semibold font-body text-primary-foreground">Ready to Transform</span>
          </div>
          
          <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold font-headline text-primary-foreground mb-6 leading-tight">
            Begin Your Assessment Journey
          </h2>
          
          <p className="text-lg text-primary-foreground/90 mb-8 max-w-2xl mx-auto font-body leading-relaxed">
            Book a discovery call to explore how our assessment framework can evaluate your organisation's AI leadership maturity and identify pathways to recognition.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <button
              onClick={onBookCall}
              className="px-8 py-4 bg-accent text-accent-foreground rounded-lg font-semibold font-cta text-base hover:bg-accent/90 transition-all duration-300 shadow-strong hover:shadow-xl hover:-translate-y-0.5 flex items-center gap-2"
            >
              Book Discovery Call
              <Icon name="CalendarIcon" size={20} variant="outline" />
            </button>
            
            <button
              onClick={() => window.location.href = '/resources'}
              className="px-8 py-4 bg-white/10 backdrop-blur-sm text-primary-foreground rounded-lg font-semibold font-cta text-base hover:bg-white/20 transition-all duration-300 flex items-center gap-2"
            >
              Download Resources
              <Icon name="ArrowDownTrayIcon" size={20} variant="outline" />
            </button>
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-3xl mx-auto">
            <div className="flex flex-col items-center gap-2">
              <div className="w-12 h-12 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center">
                <Icon name="ClockIcon" size={24} variant="outline" className="text-primary-foreground" />
              </div>
              <div className="text-sm text-primary-foreground/90 font-body text-center">
                30-Minute Discovery Call
              </div>
            </div>
            
            <div className="flex flex-col items-center gap-2">
              <div className="w-12 h-12 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center">
                <Icon name="DocumentTextIcon" size={24} variant="outline" className="text-primary-foreground" />
              </div>
              <div className="text-sm text-primary-foreground/90 font-body text-center">
                Complimentary Readiness Assessment
              </div>
            </div>
            
            <div className="flex flex-col items-center gap-2">
              <div className="w-12 h-12 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center">
                <Icon name="CheckCircleIcon" size={24} variant="outline" className="text-primary-foreground" />
              </div>
              <div className="text-sm text-primary-foreground/90 font-body text-center">
                No Obligation Consultation
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;